// Module
var code = "<div ng-transclude></div> ";
// Exports
module.exports = code;